import React from "react";

export const HeaderList: React.FC = () => {
  return (<>
    <h4 className="libraries-composition__title">
      Library Composition
    </h4>

    <div className="screen-libraries__table-small-header flex flex-ai-center flex-jc-between">
      <span className="screen-libraries__table-small-header-name">Name</span>
      <div className="screen-libraries__table-small-right flex flex-ai-center flex-jc-between">
        <span></span>
        <span>Occurrence in the library, times</span>
      </div>
    </div>
  </>);
};

export default HeaderList;
